(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlanBuildService", ['$ihttp', function ($ihttp) {
		let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1389,
                    parameters: parms || {}
                });
            },
            listBuildOns: function (parms) {
                return $ihttp.post({
                    method: 1414,
                    parameters: parms || {}
                });
            },
            listBuilds: function (parms) {
                return $ihttp.post({
                    method: 1390,
                    parameters: parms || {}
                });
            },
            listSplits: function (parms) {
                return $ihttp.post({
                    method: 1439,
                    parameters: parms || {}
                });
            },
            saveObj: function (setting) {
                return $ihttp.post({
                    method: 1410,
                    parameters: setting
                });
            },
            removeItems: function (mergeObj) {
                return $ihttp.post({
                    method: 1415,
                    parameters: mergeObj
                });
            }
		};

		return service;
	}]);
})();
